import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import Header from "../../../src/component/Header";
import IconDelete from "../../../src/component/SvgIcons/IconDelete";
import IconPen from "../../../src/component/SvgIcons/IconPen";
import IconPlus from "../../../src/component/SvgIcons/IconPlus";
import IconUpdownFilter from "../../../src/component/SvgIcons/IconUpdownFilter";
import api from "../../../src/Services/api";
import Pagination from "../../component/Pagination";
import IconKey from "../../component/SvgIcons/IconKey";
import IconSearch from "../../component/SvgIcons/IconSearch";
import { useSwal } from "../../component/sweetalert";
import "../Events/style.css";
import { formatCountryDate } from "../../Services/countryTime";
export default function UsersList() {
   const alert = useSwal();
  const [users, setUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [showPasswords, setShowPasswords] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1920) {
        setItemsPerPage(20);
      } else {
        setItemsPerPage(10);
      }
    };
    handleResize(); // Set initial value
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    // Fetch users from the API endpoint
    const fetchUsers = async () => {
      try {
        const response = await api.post("/getAllUsers");
        setUsers(response.data); // assuming response.data is the array of users        
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
    fetchUsers();
  }, []);

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  const sortedUsers = [...users].sort((a, b) => {
    if (!sortConfig.key) return 0;
    if (a[sortConfig.key] < b[sortConfig.key])
      return sortConfig.direction === "asc" ? -1 : 1;
    if (a[sortConfig.key] > b[sortConfig.key])
      return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });
  
  const filteredUsers = sortedUsers.filter((user) => {
    const formattedDate = formatCountryDate(user.DateTime)
      .replace(/\//g, "-");  
    return (
      formattedDate.includes(searchQuery) ||
      user.username.toLowerCase().includes(searchQuery.toLowerCase()) ||
      user.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
      user.address.toLowerCase().includes(searchQuery.toLowerCase()) ||
      user.type.toLowerCase().includes(searchQuery.toLowerCase()) ||
      user.contact.toLowerCase().includes(searchQuery.toLowerCase())
    );
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  //#region delete
  const handleDelete = async (id) => {
    const isConfirmed = await alert('warning', 'Do you really want to delete this user?', 'Are you sure?', {
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel'
    });  
    if (!isConfirmed) return;

    try {
     const response =  await api.post(`/deleteUser/${id}`);
      console.log(response.data);
      setUsers((prevUsers) => prevUsers.filter((user) => user.id !== id));
      
      alert('success', 'User deleted successfully');    
    } catch (error) {
      console.error("Error deleting user:", error);
      alert('error', 'An error occurred while deleting the user.', 'Oops...');       
    }
  };

  //#endregion

  return (
    <div className="eventpage">
      <Header pageTitle="User List Details" />
      <div className="pageLeftspace">

        <div className="d-flex justify-content-between align-items-center topsearchbar">
          <div className="d-flex align-items-center gap-2">
            <Link to="/add-user" className="btn btn-purpal addbutton">
              <IconPlus /> Add User
            </Link>
          <Link to="#" onClick={() => handleSort("username")}>
              <IconUpdownFilter />
            </Link>            
          </div>

          <div className="input-container">
            <input
              type="text"
              name="password"
              placeholder="Search Here.."
              id="name"
              value={searchQuery}
              onChange={handleSearchChange}
            />
            {/* <label htmlFor="password">Search here..</label> */}
            <span className="underline"></span>
            <div className="search-icon">
              <IconSearch />
            </div>
          </div>
        </div>        

        <div className="tableheader d-flex flex-column gap-4">
          <div className="event-detailstable">
            <table className="table">
              <thead>
                <tr>
                <th width="10">Sr. No.</th>
                <th>Date</th>
                  <th>User Name</th>
                  <th>
                    Password
                    <span
                      className="iconPassword"
                      onClick={() => setShowPasswords(!showPasswords)}
                    >
                      <IconKey />
                    </span>
                  </th>
                  <th>Email</th>
                  <th>Contact</th>
                  <th>Address</th>
                  <th>User Type</th>
                  <th width="80" style={{ textAlign: "center" }}>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentUsers.length > 0 ? (
                  currentUsers.map((user, index) => (
                    <tr key={user.id}>
                       <td align="center">{index + 1}</td>
                       <td> {formatCountryDate(user.DateTime).replace(/\//g, "-")}</td>                                
                      <td>{user.username}</td>
                      <td>{showPasswords ? user.password : "••••••••"}</td>
                      <td>{user.email}</td>
                      <td>{user.contact}</td>                       
                      <td>{user.address}</td>
                       <td>{user.type}</td>
                      <td style={{ textAlign: "center" }}> 
                        <span
                          className={`status-badge ${
                            user.status === true ? "status-active" : "status-deactive"
                          }`}
                        >
                         {user.status === true ? "Active" : "Deactive"}
                        </span></td>
                      <td>
                        <div className="action">
                          <Link
                            to={`/edit-user/${user.id}`}
                            className="editbtn"
                             data-tooltip-id={`edit-${user.id}`}
                            data-tooltip-content="Edit"
                          >
                            <IconPen />
                          </Link>

                          <Tooltip id={`edit-${user.id}`} place="top" />

                          <Link 
                           onClick={(e) => {
                            e.preventDefault(); // ✅ Prevent default link behavior
                            handleDelete(user.id);
                          }}
                          data-tooltip-id={`delete-${user.id}`}
                          data-tooltip-content="Delete">
                            <IconDelete />
                          </Link>
                          <Tooltip id={`delete-${user.id}`} place="top" />
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="7"
                      style={{ textAlign: "center", padding: "10px" }}
                    >
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <Pagination
            currentPage={currentPage}
            totalPages={filteredUsers.length > itemsPerPage ? totalPages : 0}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
}
